// src/hooks/useMenu.ts
import { useState, useCallback } from "react";

export interface UseMenuOptions<T = void> {
	/**
	 * Called when the user picks an item;
	 * hook will automatically close the menu afterwards.
	 */
	onSelect?: (value: T) => void;
}

export function useMenu<T = void>({ onSelect }: UseMenuOptions<T> = {}) {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = useCallback(() => {
		setIsOpen((open) => !open);
	}, []);

	const open = useCallback(() => {
		setIsOpen(true);
	}, []);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	const select = useCallback(
		(value: T) => {
			if (onSelect) onSelect(value);
			close();
		},
		[onSelect, close]
	);

	return { isOpen, toggle, open, close, select };
}
